import React from 'react';
import ReactDOM from 'react-dom/client';
import { EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';
import './config/http';   // instala el interceptor de axios antes de la 1ra llamada
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

// MSAL v4 exige initialize() antes de pedir tokens. Fijamos la cuenta activa
// para que acquireTokenSilent (config/http.js) la resuelva fuera de React.
msalInstance.initialize().then(() => {
    const cuentas = msalInstance.getAllAccounts();
    if (cuentas.length > 0) {
        msalInstance.setActiveAccount(cuentas[0]);
    }
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
            msalInstance.setActiveAccount(event.payload.account);
        }
    });

    root.render(
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    );
});
